export const ADD_MASTER_LIST = 'ADD_MASTER_LIST';

